import styled from '@emotion/styled';

const IconTextStyle = styled.div`
  margin: 50px 0px 40px 0px;
  .text {
    text-align: center;
  }
  .img {
    width: 73px;
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    margin: 50px 0px 0px 0px;
  }

  ${(props: any) => props.theme.breakpoints.down('md')} {
    margin: 10px 0px;
    .img: {
      width: 43px;
    }
    .text {
      margin: 10px 0px 0px 10px;
      text-align: left;
    }
  }
`;

export default IconTextStyle;
